import { callService } from "../tools";

export const getBeneficiosGnp = () => {
    return dispatch => {
        dispatch({"type": "LOADER_SHOW"});

        let request = {
          "clienteUnico": getClienteUnico()
        };

        new callService({
          service: "beneficiosGnp.listaBeneficiosGnp",
          "secure": true,
          data: request,
          json: true
        }).execute().then(body => {
          dispatch({ "type": "LOADER_HIDE" });          
				  dispatch({
            "type": "BENEFICIOS_LLENAR",
            "beneficiosGnp": body,
            showBeneficiosText:body.length > 0 ? '':'Espera pronto más beneficios por ser Cliente GNP'
          });
        }).catch(error => {
          dispatch({ "type": "LOADER_HIDE"}); 
          dispatch({
            "type": "BENEFICIOS_LLENAR",
            "beneficiosGnp": [],
            showBeneficiosText:'Espera pronto más beneficios por ser Cliente GNP'
          });                 
        });
    }
}

const getClienteUnico = () => {
  for (var i = 0; i < localStorage.length; i++) {
    let keys = localStorage.key(i);
    if (keys.match(/firebase:authUser:/g)) {
      let user = JSON.parse(localStorage.getItem(keys));
      return user.uid;
    }; 
  };
};


// WEBPACK FOOTER //
// ./src/Beneficios/beneficios.act.js